import { render, staticRenderFns } from "./ContractsRecordProducts.vue?vue&type=template&id=0b40ab0c"
import script from "./ContractsRecordProducts.vue?vue&type=script&lang=js"
export * from "./ContractsRecordProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports